"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledChecklist = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledChecklist = _styledComponents.default.div.withConfig({
  displayName: "Checkliststyles__StyledChecklist",
  componentId: "sc-1clhldx-0"
})(["margin:", " auto;.c-checklist-title{margin-bottom:", ";text-align:center;width:100%;}.c-checklist-items-wrapper{margin:0 auto;}.c-checklist-item-content{max-width:", ";padding:", " 0;}.c-checklist-item-icon{text-align:right;vertical-align:middle;width:3rem;}"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.componentSizeMed;
}, function (props) {
  return props.theme.standardPadding;
});

exports.StyledChecklist = StyledChecklist;